var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col p-3 pt-6 sm:p-6"},[_c('Khead'),_c('KJobFailedMessage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }